module.exports = __webpack_public_path__ + "img/cerveza.114db504.png";